export default function MuiPortal() {
  return {};
}
